<template>
  <div class="wrapper">
    <div class="info" v-on:click="openWin">
      <img src="../../assets/img/sy/weekRank/gzsm.png"/>
    </div>
    <div class="count-down-box">
      <van-count-down :time="time">
        <template v-slot="timeData">
          <span class="day">
            <span class="w">{{ format(timeData.days)[0] }}</span>
            <span class="w">{{ format(timeData.days)[1] }}</span>
          </span>
          <span class="timeText">天</span>
          <span class="hour">
            <span class="w">{{ format(timeData.hours)[0] }}</span>
            <span class="w">{{ format(timeData.hours)[1] }}</span>
          </span>
          <span class="timeText">时</span>
          <span class="min">
            <span class="w">{{ format(timeData.minutes)[0] }}</span>
            <span class="w">{{ format(timeData.minutes)[1] }}</span>
          </span>
          <span class="timeText">分</span>
        </template>
      </van-count-down>
    </div>
    <div :class="['list-tabs', `active${weekActive}`]">
      <van-tabs
        line-height="0"
        @click="changeTab">
        <van-tab title="本周榜单">
          <div class="btnBox">
            <div :class="[{active: thisActive == 0}]" @click="changeList('thisActive',0)"></div>
            <div :class="[{active: thisActive == 1}]" @click="changeList('thisActive',1)"></div>
          </div>
          <div class="gift-list">
            <div class="gift-one"
                 v-for="(item,index) in gifts"
                 v-on:click="changeGift(index)"
                 :class="[{active: index===data[0].giftIndex}]"
                 :key="index">
              <div class="gift-img" :style="{backgroundImage: `url(${item.icon})`}"></div>
              <div class="gift-name">{{item.name}}</div>
            </div>
          </div>
          <div class="list">
            <van-list
              v-model="data[0].loading"
              :finished="data[0].finished"
              finished-text="只显示前50名"
              :offset="50"
              @load="getList">
              <table cellpadding="0" cellspacing="0">
                <thead>
                <tr>
                  <td>排名</td>
                  <td>头像</td>
                  <td>昵称</td>
                  <td>{{cellName}}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in data[0].list" v-on:click="openUserWin(item.userid)">
                  <td>{{index>2?index+1:''}}</td>
                  <td>
                    <div class="avatar">
                      <img :src="item.avatar_imgurl || 'https://i0.letvimg.com/lc04_lemf/201906/12/20/07/2x.png'"/>
                    </div>
                  </td>
                  <td>
                    <div>{{item.username || '神秘人物'}}</div>
                  </td>
                  <td>
                    <div>{{item.sum}}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </van-list>
          </div>
        </van-tab>
        <van-tab title="上周榜单">
          <div class="btnBox">
            <div :class="[{active: lastActive == 0}]" @click="changeList('lastActive',0)"></div>
            <div :class="[{active: lastActive == 1}]" @click="changeList('lastActive',1)"></div>
          </div>
          <div class="gift-list">
            <div class="gift-one"
                 v-for="(item,index) in gifts"
                 v-on:click="changeGift(index)"
                 v-if="item.id!==83"
                 :class="[{active: index===data[1].giftIndex}]">
              <div class="gift-img" :style="{backgroundImage: `url(${item.icon})`}"></div>
              <div class="gift-name">{{item.name}}</div>
            </div>
          </div>
          <div class="list">
            <van-list
              v-model="data[1].loading"
              :finished="data[1].finished"
              finished-text="只显示前50名"
              :offset="50"
              @load="getList">
              <table cellpadding="0" cellspacing="0">
                <thead>
                <tr>
                  <td>排名</td>
                  <td>头像</td>
                  <td>昵称</td>
                  <td>{{cellName}}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in data[1].list" v-on:click="openUserWin(item.userid)">
                  <td>{{index>2?index+1:''}}</td>
                  <td>
                    <div class="avatar">
                      <img :src="item.avatar_imgurl || 'https://i0.letvimg.com/lc04_lemf/201906/12/20/07/2x.png'"/>
                    </div>
                  </td>
                  <td>
                    <div>{{item.username || '神秘人物'}}</div>
                  </td>
                  <td>
                    <div>{{item.sum}}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </van-list>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
  import { Tabs, Tab, List, Cell, CountDown } from 'vant';
  import axios from 'axios';
  import moment from 'moment';
  import dsbridge from '../../components/dsbridge';

  const rankAllImg = require('../../assets/img/sy/list/all.png')

  export default {
    name: 'sy_rank_week',
    data () {
      return {
        time: 0,
        weekActive: 0,
        thisActive: 0,
        lastActive: 0,
        giftIndex: 0,
        gifts: [],
        pageSize: 10,
        data: [{
          list: [],
          page: 1,
          giftIndex: 0,
          loading: false,
          finished: false
        }, {
          list: [],
          page: 1,
          giftIndex: 0,
          loading: false,
          finished: false
        }],
        API_DOMAIN: window.location.host.match(/mp-cdn\.le/) ?
          'https://api-svoice.le.com' : 'https://test-api-svoice.le.com',
          // 'http://api.svoice.le.com' : 'http://test.api.svoice.le.com',
        APIS: [
          '/topstreamer/income',
          '/topuser/outcome'
        ],
        WEEKS:[
          'commevent/thisweek',
          'commevent/lastweek'
        ],

        API_CONFIG: '/sales/',
        cellName: '数量'
      }
    },
    computed: {},
    async mounted () {
      this.timeDowm();
      await this.getWeekGift();
    },
    methods: {
      async getWeekGift (){
        this.gifts = [];//初始化一下 不保存了容易出现请求多次的情况
        try {
          const ret = await axios.get(`${this.API_DOMAIN}${this.API_CONFIG}${this.WEEKS[this.weekActive]}`, { timeout: 3000 });
          const data = ret.data && ret.data.data;
          if (data.code === 0) {
            this.$notify('获取活动信息失败，请刷新页面')
          } else {
            const gifts = data.gifts.list.map((gift) => {
              return {
                id: gift.giftid,
                name: gift.name,
                icon: gift.icon
              }
            });
            this.gifts = gifts;
            await this.changeGift();
          }
        } catch (e) {
          this.$notify('获取活动信息失败，请刷新页面')
        }
      },
      async changeTab (name, title) {
        this.weekActive = parseInt(name);
        await this.getWeekGift();
      },
      async getList () {
        // 异步更新数据
        if (this.gifts.length === 0) return;
        this.data[this.weekActive].loading = true;
        const giftId = this.gifts[this.data[this.weekActive].giftIndex].id;
        let ret,
            active = 0;
        if (this.weekActive == 1){
          active = this.lastActive;
        } else {
          active = this.thisActive;
        }
        try {
          ret = await axios.get(`${this.API_DOMAIN}${this.API_CONFIG}${this.WEEKS[this.weekActive]}${this.APIS[active]}?giftid=${giftId}&pagenum=${this.data[this.weekActive].page}&pagesize=${this.pageSize}`, { timeout: 3000 })
        } catch (e) {
          try {
            ret = await axios.get(`${this.API_DOMAIN}${this.API_CONFIG}${this.WEEKS[this.weekActive]}${this.APIS[active]}?giftid=${giftId}&pagenum=${this.data[this.weekActive].page}&pagesize=${this.pageSize}`, { timeout: 3000 })
          } catch (e) {
            this.$notify(ret && ret.data && ret.data.message || '网络错误，请稍候再试')
            return
          }
        }
        const list = ret.data && ret.data.data && ret.data.data.list || [];
        const oldList = this.data[this.weekActive].list;
        const newList = Array.prototype.concat(oldList, list);
        this.data[this.weekActive].list = newList;
        // 加载状态结束
        this.data[this.weekActive].loading = false;
        // 数据全部加载完成
        if (list.length === 0) {
          this.data[this.weekActive].finished = true;
          return
        }
        this.data[this.weekActive].page++
      },
      async changeGift (index) {
        this.data[this.weekActive].giftIndex = typeof(index) == 'undefined' ? this.data[this.weekActive].giftIndex : index;
        this.data[this.weekActive].list = []
        this.data[this.weekActive].page = 1
        this.data[this.weekActive].finished = false
        this.data[this.weekActive].loading = false
        // if (index === this.gifts.length - 1) {
        //   this.cellName = '蜜豆'
        // } else {
        //   this.cellName = '数量'
        // }
        await this.getList()
      },
      async changeList (activeDom,active) {
        this[activeDom] = active;
        await this.changeGift();
      },
      format (t) {
        return (t + '').length === 1 ? '0' + t : ''+t
      },
      openWin () {
        const url = window.location.href.replace('/rank', '/rank/info?id=5')
        if (dsbridge.hasNativeMethod('openWebView')) {
          const param = {
            url
          }
          dsBridge.call('openWebView', param)
        } else {
          window.open(url, '_blank')
        }
      },
      openUserWin (uid) {
        if (dsbridge.hasNativeMethod('openUserWin')) {
          const param = {
            uid
          }
          dsBridge.call('openUserWin', param)
        } else {
          // this.$notify('请在app中打开或升级当前app版本')
        }
      },
      timeDowm (){
        const nowDay = moment().format('x'),//当前时间
              nextWeekDay = moment(moment().endOf('week')).format('x');//获取下周一时间
        this.time = nextWeekDay - nowDay;
      }
    },
    watch: {},
    components: {
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [List.name]: List,
      [Cell.name]: Cell,
      [CountDown.name]: CountDown
    }
  }
</script>

<style>
  @font-face {
    font-family: "WenYueXinQingNianTi-W8";
    src: url("../../assets/font/WenYueXinQingNianTi-W8.ttf");
    src: url('../../assets/font/WenYueXinQingNianTi-W8.eot');
    src: url('../../assets/font/WenYueXinQingNianTi-W8.eot?#iefix') format('embedded-opentype'),
    url('../../assets/font/WenYueXinQingNianTi-W8.woff2') format('woff2'),
    url('../../assets/font/WenYueXinQingNianTi-W8.woff') format('woff'),
    url('../../assets/font/WenYueXinQingNianTi-W8.ttf') format('truetype'),
    url('../../assets/font/WenYueXinQingNianTi-W8.svg#ciclefina') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  body, html {
    min-height: 100%;
    background-color: rgb(255, 215, 223);
  }

  #app {
    min-height: 100%;
    background: url("../../assets/img/sy/weekRank/bg.png") 0 0 no-repeat rgb(255, 215, 223);
    background-size: 100% auto;
    /*opacity: 0;*/
    font-size: 12px;
  }
  .btnBox {
    width: 80%;
    display:flex;
    justify-content : center;
    margin: auto 12%;
  }
  
  .btnBox div{
    width: 50%;
	  height: 35px;
    margin-bottom: 13px;
  }
  .btnBox div:nth-child(1) {
    margin-right: -6px;
    background: url('../../assets/img/sy/weekRank/zbwxz.png')  0 0 no-repeat;
    background-size: 100% auto;
  }
  .btnBox div.active:nth-child(1) {
    background: url('../../assets/img/sy/weekRank/zbxz.png')  0 0 no-repeat;
    background-size: 100% auto;
  }
  .btnBox div:nth-child(2) {
    margin-left: -6px;
    background: url('../../assets/img/sy/weekRank/fhwxz.png')  0 0 no-repeat;
    background-size: 100% auto;
  }
  .btnBox div.active:nth-child(2) {
    background: url('../../assets/img/sy/weekRank/fhxz.png')  0 0 no-repeat;
    background-size: 100% auto;
  }
  .btnBox:after {
    content:".";        
    display:block;        
    height:0;        
    clear:both;        
    visibility:hidden;
  }
  .wrapper {
    min-height: 100%;
    overflow: hidden;
  }

  .wrapper .info {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 75px;
	  height: 60px;
  }
  .wrapper .info img {
    width: 75px;
	  height: 60px;
  }
  .count-down-box {
    position: relative;
    top: 169px;
    left: 50%;
    margin-left: -123px;
    width: 240px;
    height: 45px;
    background-image: linear-gradient(0deg, 
      #ff2659 0%, 
      #ff6388 100%);
    box-shadow: 0px 4px 12px 0px 
      rgba(255, 56, 103, 0.6);
    border: 3px solid #ff8ca7;
    /* border-image: linear-gradient(#ff8ca7 0%, #ffb2c4 100%); */
    border-radius:24px;
  }
  .van-count-down {
    text-align: center;
    line-height: 51px;
  }
  .count-down-box .timeText {
    font-family: "WenYueXinQingNianTi-W8";
    font-size: 21px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 21px;
    letter-spacing: 1px;
    color: #ffffff;
    margin-right:2px;
  }
  .count-down-box .w {
    display: inline-block;
    width: 21px;
    height: 27px;
    text-align: center;
    background-image: linear-gradient(0deg, 
		#ffcad7 0%, 
		#fffefe 100%);
	  border-radius: 3px;
    font-family: PingFangSC-Medium;
    font-size: 19px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 27px;
    letter-spacing: 1px;
    color: #ff4672;
    margin-right:3px;
  }
  .count-down-box .day {
    /* position: absolute; */
    right: 205px;
    top: 16px;
  }

  .count-down-box .hour {
    /* position: absolute; */
    right: 129px;
    top: 16px;
    /* width:46px; */
  }

  .count-down-box .min {
    /* position: absolute; */
    right: 63px;
    top: 16px;
    /* width: 46px; */
  }

  .list-tabs {
    margin-top: 200px;
    padding: 0 13px;
  }

  .list-tabs .van-tabs--line .van-tabs__wrap {
    width: 349px;
    background-image: linear-gradient(0deg, 
      #ff6600 0%, 
      #ffa556 100%);
	  box-shadow: inset 0px -1px 3px 0px
      rgba(255, 193, 83, 1), 
      inset 0px -3px 4px 0px 
      rgba(255, 121, 26, 0.8), 
      inset 0px 3px 6px 0px 
      rgba(255, 190, 82, 1);
    font-size: 16px;
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
    line-height: 40px;
    height: 40px;
    color: #fff;
    margin: 0 auto;
  }

  .list-tabs .van-tab {
    position: relative;
    color: #fff;
    opacity: 0.8;
    font-weight: none;
    text-align: center;
    cursor: pointer;
    line-height: 40px;
  }

  .list-tabs .van-tab.van-tab--active {
    opacity: 1;
    font-weight: none;
  }
  .list-tabs .van-tab.van-tab--active:after{
    position: absolute;
    bottom: 4px;
    left: 50%;
    margin-left: -12px;
    content: '';
    width: 20px;
    height: 1px;
    border: 1px solid #fff;
    background-color: #ffffff;
    border-radius: 2px;
  }
  .list-tabs .van-tab:nth-child(1) {
    width: 175px;
    left: 0;
  }

  .list-tabs .van-tab:nth-child(2) {
    width: 175px;
    right: 0;
  }

  .list-tabs .van-tabs__nav {
    background: transparent;
  }
  .van-tabs__nav--line {
    box-sizing: content-box;
    height: 100%;
    padding-bottom: 0;
  }
  /* .list-tabs .van-tab--active {
  } */

  .list-tabs .van-hairline--top-bottom::after {
    display: none;
  }

  .list-tabs .van-tab__pane {
    padding-top: 20px;
    background: #fff;
    min-height: 500px;
  }

  .list-tabs .van-loading__text, .list-tabs .van-list__finished-text {
    color: rgb(201, 201, 201);
  }

  .list-tabs .van-cell {
    background-color: #FFF2ED;
  }

  .list-tabs .van-cell:not(:last-child)::after {
    left: 0;
    border-color: rgba(0, 0, 0, 0.08);
  }

  .list-tabs .list {
    border-radius: 10PX;
    /* background-color: #FFF2ED; */
  }

  .list-tabs table {
    width: 90%;
    text-align: center;
    margin: 0 auto;
    border-collapse: separate;
  }
  .list-tabs table thead {
    background-color: #f7f7f7;
    border-radius: 10px;
    line-height: 30px;
  }

  .list-tabs table tr td {
    position: relative;
  }
  .list-tabs table tr td:nth-child(1) {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    width: 60px;
  }

  .list-tabs table tr td:nth-child(2) {
    width: 60px;
  }

  .list-tabs table .avatar {
    position: absolute;
    width: 40px;
    height: 40px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url("https://i0.letvimg.com/lc04_lemf/201906/12/20/07/2x.png") no-repeat;
    background-size: 40px;
    border-radius: 20px;
    overflow: hidden;
  }

  .list-tabs table .avatar img {
    width: 100%;
  }

  .list-tabs table tr td:nth-child(3) {
    width: 110px;
  }

  .list-tabs table tr td:nth-child(3) div {
    width: 100px;
    padding: 0 5px;
    line-height: 65px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .list-tabs table tr td:nth-child(4) {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 100px;
  }

  .list-tabs table tr td:nth-child(4) div {
    width: 90px;
    padding: 0 5px;
    line-height: 65px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #ff4470;
  }

  .list-tabs table tr:not(:last-child) td::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 1PX solid rgba(0, 0, 0, 0.08);;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .list-tabs tbody {
    font-size: 14px;
  }

  .list-tabs tbody img {
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }

  .list-tabs table tbody tr:nth-child(1) td:nth-child(1) {
    background: url("../../assets/img/sy/weekRank/no1.png") center no-repeat;
    background-size: 40px 40px;
  }

  .list-tabs table tbody tr:nth-child(2) td:nth-child(1) {
    background: url("../../assets/img/sy/weekRank/no2.png") center no-repeat;
    background-size: 40px 40px;
  }

  .list-tabs table tbody tr:nth-child(3) td:nth-child(1) {
    background: url("../../assets/img/sy/weekRank/no3.png") center no-repeat;
    background-size: 40px 40px;
  }

  .gift-list {
    padding: 0 0 12px;
    display: flex;
    flex-direction:row;
    justify-content: space-around;
    text-align: center;
    color: #fff;
    line-height: 25px;
    font-weight: bold;
    width: 90%;
    margin: 0 auto;
  }

  .gift-list.gift-list-two {
    width: 60%;
  }

  .gift-list .gift-one {
    display: inline-block;
    position: relative;
    max-width: 30%;
    flex:1;
    border-radius: 4px;
    background-image: linear-gradient(0deg, 
		#d3d3d3 0%, 
		#e4e4e4 100%);
    box-shadow: inset 0px -1px 2px 0px 
      rgba(255, 255, 255, 0.8), 
      inset 0px -6px 8px 0px 
      rgba(209, 209, 209, 0.6), 
      inset 0px 4px 6px 0px 
      rgba(255, 255, 255, 0.8);
  }

  .gift-list .gift-one:before {
    position: absolute;
    content: '';
    opacity: 0;
    bottom: -8px;
    left: 50%;
    transform: translate(-50%, 0);
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-color: #ffb11c transparent transparent transparent;
  }

  .gift-list .gift-one:after {
    position: absolute;
    opacity: 0;
    content: '';
    bottom: -5px;
    left: 50%;
    transform: translate(-50%, 0);
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-color: #ffb11c transparent transparent transparent;
  }

  .gift-list .gift-one.active {
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.50);
    background-image: linear-gradient(0deg, 
		#ffb11c 0%, 
		#ffda48 100%);
    box-shadow: inset 0px -1px 2px 0px 
      rgba(255, 217, 70, 0.8), 
      inset 0px -6px 8px 0px 
      rgba(255, 181, 32, 0.6), 
      inset 0px 4px 6px 0px 
      rgba(255, 216, 70, 0.8);
  }

  .gift-list .gift-one.active:before, .gift-list .gift-one.active:after {
    opacity: 1;
  }

  .gift-list .gift-img {
    height: 60px;
    background-position: center;
    background-size: 56px auto;
    background-repeat: no-repeat;
  }
</style>
